<span *ngIf="nested">
  <a uiSref="groups-show" [uiParams]="{ groupId: activity.trackableId }"
    >&#35;{{ index + 1 }}</a
  >
</span>
<span *ngIf="!nested">
  <span class="capitalize">{{ activity.activity.split(".")[1] }}</span>
  <span
    *ngIf="
      activity.subActivities &&
      activity.subActivities[activity.activity].length <= 1
    "
  >
    an
    <a uiSref="groups-show" [uiParams]="{ groupId: activity.trackableId }"
      >error</a
    >
  </span>
  <span
    *ngIf="
      activity.subActivities &&
      activity.subActivities[activity.activity].length > 1
    "
  >
    <button
      class="btn btn--link btn--no-shadow ml-1"
      (click)="toggleShowNested()"
    >
      {{ activity.subActivities[activity.activity].length }} errors
    </button>
  </span>
</span>
<ul class="list-inline list-unstyled" *ngIf="showNested">
  <li
    class="list-inline-item comma-list-item"
    *ngFor="
      let subActivity of visibleSubActivities[activity.activity];
      index as $index;
      trackBy: trackByTrackableId
    "
  >
    <ab-group-activity
      [activity]="subActivity"
      [nested]="true"
      [index]="$index"
    ></ab-group-activity>
  </li>
</ul>
